exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-padding[data-v-97b9b718]{padding-left:10px}@media screen and (max-width:576px){.text-padding[data-v-97b9b718]{padding-left:0}}.categories-options[data-v-97b9b718]{cursor:pointer;font-weight:700}hr[data-v-97b9b718]{margin-top:.85rem;margin-bottom:.85rem}", ""]);

// exports
